// extracted by mini-css-extract-plugin
export default {"success":"Notification_success__lnXcX","error":"Notification_error__KWpYe"};